<app-navbar></app-navbar>    

<div id="main-content" class="animated fadeIn">
    <div class="container-fluid">

    <!-- contenido-->
        <div class="block-header">
            <div class="row clearfix">
                <div class="col-md-6 col-sm-12">
                    <h1 class="color">Perfil</h1>
                    <div class="header">
                        <p style="cursor: pointer;" class="color" [routerLink]="['/home']"><i class="fa fa-angle-left " style="font-size: 19px;" aria-hidden="true"></i> Gestor de Tareas / <span class="" style="color: #a5a8ad;">Perfil</span></p>
                    </div>
                </div>            
                
            </div>
           
        </div>

        <div class="card animated fadeIn" style="margin-top: 10px;">
            <div class="body" > 
                <div class="d-flex">
                    <div class="mr-3">
                        <img src="{{url+''+img}}" style="width: 50px;" class="rounded" alt="">
                    </div>
                    <div class="details">
                        <h5 class="mb-0">Hola, administrador!</h5>
                        <span class="text-light">Puedes actualizar la información sobre ti en esta página.</span>
                        <!-- <p class="mb-0"><span>Posts: <strong>321</strong></span> <span>Followers: <strong>4,230</strong></span> <span>Following: <strong>560</strong></span></p> -->
                    </div>                                
                </div>
            </div>
        </div>

        <div class="card animated fadeIn" style="margin-top: 10px;">
          <div class="header color">Actualizar los datos</div>
            <div class="body" >

              <form  class="justify-content-center" #infoForm="ngForm" (ngSubmit)="info_form(infoForm)">
                <div class="row justify-content-center" >
                  <div class="col-md-4 col-sm-12">
                    <div class="form-group">
                      <label for="">Nombre</label>
                    <input type="text" placeholder="Nombre" class="form-control txt_cat" style="width: 100%;"  name="nombre"  #nombre="ngModel"  [(ngModel)]="editUser.nombre" required >
                  </div>
                </div>
                  <div class="col-md-4 col-sm-12">
                    <div class="form-group">
                      <label for="">Apellido</label>
                    <input type="text" placeholder="Apellido" class="form-control txt_cat" style="width: 100%;" name="apellido"  #apellido="ngModel"  [(ngModel)]="editUser.apellido" required  >
                  </div>
                </div>
                  <div class="col-md-4 col-sm-12">
                    <div class="form-group">
                      <label for="">Email</label>
                    <input type="text" placeholder="Email" class="form-control txt_cat" style="width: 100%;"  name="email"  #email="ngModel"  [(ngModel)]="editUser.email" required >
                  </div>
                </div>
                    <div class="col-md-4 col-sm-12">
                      <button type="submit" class="btn btn-primary  btn-round btn-block"  [disabled]="!infoForm.form.valid || loadingInfo">
                        <i class="fa " aria-hidden="true"  [ngClass]="{ 'fa-save':!loadingInfo, ' fa-refresh fa-spin':loadingInfo }"></i>
                        Guardar
                        </button>
                    </div>
                  </div>
                </form>

          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="card animated fadeIn" style="margin-top: 10px;">
              <div class="header color">Editar Contraseña</div>
                <div class="body" >
                  
                  <form  class="" #passForm="ngForm" (ngSubmit)="pass_form(passForm)">
                    <div class="row justify-content-center" style="">
                      <div class="col-md-6 col-sm-12">
                        <div class="form-group">
                           <input [type]="show ? 'text' : 'password'" placeholder="Nueva Contraseña" class="form-control " style="width: 100%;"  name="npass"  #npass="ngModel"  [(ngModel)]="editPass.nombre" required>
                        </div>
                        </div>
                      <div class="col-md-6 col-sm-12">
                        <div class="form-group">
                           <input [type]="show ? 'text' : 'password'" placeholder="Confirme la Contraseña" class="form-control " style="width: 100%;"  name="rpass"  #rpass="ngModel"  [(ngModel)]="editPass.apellido" required>
                          
                          </div>
                          <a style="float: right; cursor: pointer;" (click)="password()">Ver Contraseña</a>
                        </div>

                    </div>
                    <span *ngIf="pass_error">
                      La contraseña con conincide

                  </span>
                    <br>
                    <div class="row justify-content-center">
                        <div class="col-md-4 col-sm-12">
                          <button type="submit" class="btn btn-primary  btn-round btn-block"  [disabled]="!passForm.form.valid || loadingPass">
                            <i class="fa " aria-hidden="true"  [ngClass]="{ 'fa-save':!loadingPass, ' fa-refresh fa-spin':loadingPass }"></i>
                            Guardar
                            </button>
                        </div>
                      </div>
                    </form>
    
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="card animated fadeIn" style="margin-top: 10px;">
              <div class="header color">Cambiar Imagen</div>
                <div class="body" >
                  
                  <form #imageForm="ngForm" (ngSubmit)="cambiar_imagen(imageForm)" class="">
                    <div class="row justify-content-center">
                      <div class="col-md-8 col-sm-12">
                        <!-- (change)="fileEvent($event)" -->
                        <div class="form-group">
                          <div class="custom-file">
                            <input type="file" class="custom-file-input" id="inputGroupFile01"  name="imagen"  #imagen="ngModel" (change)="fileEvent($event)"  [(ngModel)]="editUser.file" required>
                            <label class="custom-file-label" for="inputGroupFile01">Selecciona una Imagen</label>
                          </div>
                          <!-- <input type="file"  name="imagen"  #imagen="ngModel" (change)="fileEvent($event)"  [(ngModel)]="editUser.file" class="form-control txt_cat" style="width: 100%;" id="txt_cat" required> -->
                        </div>
                        <div *ngIf="fileUploadProgress">
                          <!-- Upload progress: {{ fileUploadProgress }} -->
        
                          <div class="progress">
                            <div class="progress-bar" role="progressbar" [ngStyle]="{width: fileUploadProgress + '%'}" aria-valuemin="0" aria-valuemax="100"></div>
                          </div>
                      </div>
                        <div class="image-preview mb-3" *ngIf="previewUrl">
                          <img [src]="previewUrl" height="300" />                 
                      </div>
                      </div>
                        <div class="col-md-4 col-sm-12">
                          <button type="submit" class="btn btn-primary  btn-round btn-block fa"  [disabled]="!imageForm.form.valid || loadingImage">
                            <i class="fa " aria-hidden="true"  [ngClass]="{ 'fa-save':!loadingImage, ' fa-refresh fa-spin':loadingImage }"></i>
                            Guardar
                            </button>
                        </div>
                      </div>
                    </form>
    
              </div>
            </div>
          </div>
         
        </div>
        


        

    </div>
</div>